// extracted by mini-css-extract-plugin
module.exports = {"AboutText":"about-module--AboutText--1IsJV","AboutImage":"about-module--AboutImage--2Gw-9","separator":"about-module--separator--2xL3T","About":"about-module--About--1A6BT"};